export const getRootCause = (e) => {
    let rootCause = e;
    while (rootCause?.cause) {
        rootCause = rootCause.cause;
    }
    return rootCause;
};
//# sourceMappingURL=rootCause.js.map